<template>
  <div>
    <div class="card p-4 shadow-sm">
      <!-- ✅ Toast -->
      <div
        v-if="mostrarToast"
        class="toast-container position-fixed top-0 end-0 p-3"
        style="z-index: 1055"
      >
        <div class="toast show align-items-center text-white" :class="toastColor">
          <div class="d-flex">
            <div class="toast-body">
              <i :class="iconoToast" class="me-2"></i>
              {{ alerta.mensaje }}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
          </div>
        </div>
      </div>

      <!-- ✅ Encabezado -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h3 class="m-0">Habitaciones</h3>
        <div>
          <button class="btn btn-info me-2" @click="abrirModalTipos">
            <i class="bi bi-house-gear me-1"></i>Gestionar Tipos
          </button>
          <button class="btn btn-success" @click="mostrarFormulario = true">
            <i class="bi bi-plus-circle me-1"></i>Agregar Habitación
          </button>
        </div>
      </div>

      <!-- ✅ Formulario Crear -->
      <div v-if="mostrarFormulario" class="mb-4">
        <h5 class="mb-3">Nueva Habitación</h5>
        <div class="row g-3">
          <div class="col-md-3">
            <label class="form-label">Número</label>
            <input v-model="nuevaHabitacion.Numero" type="text" class="form-control" />
          </div>
          <div class="col-md-3">
            <label class="form-label">Tipo</label>
            <select v-model="nuevaHabitacion.IdTipoHabitacion" class="form-select">
              <option disabled value="">Seleccione un tipo</option>
              <option v-for="tipo in tiposHabitacion" :key="tipo.IdTipoHabitacion" :value="tipo.IdTipoHabitacion">
                {{ tipo.Nombre }}
              </option>
            </select>
          </div>
          <div class="col-md-3">
            <label class="form-label">Cantidad de Camas</label>
            <input v-model.number="nuevaHabitacion.CantidadCamas" type="number" min="1" class="form-control" />
          </div>
          <div class="col-md-3">
            <label class="form-label">Nivel (Opcional)</label>
            <input v-model="nuevaHabitacion.Nivel" type="text" class="form-control" placeholder="Ej: 1er piso" />
          </div>
          <div class="col-md-12">
            <label class="form-label">Descripción (Opcional)</label>
            <textarea v-model="nuevaHabitacion.Descripcion" class="form-control" rows="2" placeholder="Detalles adicionales de la habitación..."></textarea>
          </div>
        </div>
        <div class="text-end mt-3">
          <button class="btn btn-primary me-2" @click="guardarHabitacion">Guardar</button>
          <button class="btn btn-secondary" @click="cancelarFormulario">Cancelar</button>
        </div>
      </div>

      <!-- ✅ Filtros y Búsqueda -->
      <div class="card mb-4 p-3 bg-light">
        <div class="row g-3">
          <div class="col-md-3">
            <label class="form-label"><i class="bi bi-search me-2"></i>Buscar por Número</label>
            <input
              v-model="busquedaNumero"
              type="text"
              class="form-control"
              placeholder="Ej: 101, 102..."
            />
          </div>
          <div class="col-md-3">
            <label class="form-label"><i class="bi bi-door-closed me-2"></i>Filtrar por Tipo</label>
            <select
              v-model="filtroTipo"
              class="form-select"
            >
              <option value="">Todos los tipos</option>
              <option v-for="tipo in tiposHabitacion" :key="tipo.IdTipoHabitacion" :value="tipo.IdTipoHabitacion">
                {{ tipo.Nombre }}
              </option>
            </select>
          </div>
          <div class="col-md-3">
            <label class="form-label"><i class="bi bi-info-circle me-2"></i>Filtrar por Estado</label>
            <select
              v-model="filtroEstado"
              class="form-select"
            >
              <option value="">Todos los estados</option>
              <option value="1">Ocupado</option>
              <option value="2">Espera de limpieza</option>
              <option value="3">Limpieza</option>
              <option value="4">Disponible</option>
              <option value="5">Bloqueado</option>
              <option value="7">Mantenimiento</option>
            </select>
          </div>
          <div class="col-md-3 d-flex align-items-end">
            <button class="btn btn-outline-secondary btn-sm w-100" @click="limpiarFiltros">
              <i class="bi bi-arrow-counterclockwise me-1"></i>Limpiar Filtros
            </button>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <span class="texto-resultados ms-0 text-muted">
              Mostrando {{ habitacionesFiltradas.length }} de {{ habitaciones.length }} habitaciones
            </span>
          </div>
        </div>
      </div>

      <!-- ✅ Tabla -->
      <div class="table-responsive">
        <table class="table table-bordered text-center align-middle">
          <thead class="table-light">
            <tr>
              <th>Número</th>
              <th>Tipo</th>
              <th>Camas</th>
              <th>Nivel</th>
              <th>Estado</th>
              <th>Descripción</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="habitacionesFiltradas.length === 0">
              <td colspan="7" class="text-muted">No hay habitaciones que coincidan con los filtros.</td>
            </tr>
            <tr v-for="hab in habitacionesFiltradas" :key="hab.IdHabitacion">
              <td>{{ hab.Numero }}</td>
              <td>{{ hab.tipo?.Nombre }}</td>
              <td>{{ hab.CantidadCamas }}</td>
              <td>{{ hab.Nivel || '—' }}</td>
              <td>
                <span :class="getEstadoClase(hab.estado?.IdEstado)" class="badge">
                  {{ hab.estado?.Estado || 'Desconocido' }}
                </span>
              </td>
              <td>
                <small>{{ hab.Descripcion ? (hab.Descripcion.length > 50 ? hab.Descripcion.substring(0, 50) + '...' : hab.Descripcion) : '—' }}</small>
              </td>
              <td>
                <button class="btn btn-primary btn-sm me-2" @click="abrirModal(hab)">Editar</button>
                <button v-if="hab.estado?.IdEstado !== 4" class="btn btn-success btn-sm me-2" @click="cambiarADisponible(hab)">Disponible</button>
                <button class="btn btn-danger btn-sm" @click="abrirModalEliminar(hab)">Eliminar</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- ✅ Modal Actualizar -->
      <div v-if="mostrarModal" class="modal-backdrop">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Actualizar Habitación</h5>
            <button type="button" class="btn-close" @click.stop="cerrarModal"></button>
          </div>
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label">Número</label>
                <input v-model="habitacionEditar.Numero" type="text" class="form-control" />
              </div>
              <div class="col-md-6">
                <label class="form-label">Tipo</label>
                <select v-model="habitacionEditar.IdTipoHabitacion" class="form-select">
                  <option disabled value="">Seleccione un tipo</option>
                  <option v-for="tipo in tiposHabitacion" :key="tipo.IdTipoHabitacion" :value="tipo.IdTipoHabitacion">
                    {{ tipo.Nombre }}
                  </option>
                </select>
              </div>
              <div class="col-md-6">
                <label class="form-label">Cantidad de Camas</label>
                <input v-model.number="habitacionEditar.CantidadCamas" type="number" min="1" class="form-control" />
              </div>
              <div class="col-md-6">
                <label class="form-label">Nivel (Opcional)</label>
                <input v-model="habitacionEditar.Nivel" type="text" class="form-control" placeholder="Ej: 1er piso" />
              </div>
              <div class="col-md-6">
                <label class="form-label">Estado</label>
                <select v-model="habitacionEditar.IdEstado" class="form-select">
                  <option :value="1">Ocupado</option>
                  <option :value="2">Espera de limpieza</option>
                  <option :value="3">Limpieza</option>
                  <option :value="4">Disponible</option>
                  <option :value="5">Bloqueado</option>
                  <option :value="7">Mantenimiento</option>
                </select>
              </div>
              <div class="col-md-12">
                <label class="form-label">Descripción (Opcional)</label>
                <textarea v-model="habitacionEditar.Descripcion" class="form-control" rows="2" placeholder="Detalles adicionales de la habitación..."></textarea>
              </div>
            </div>
          </div>
          <div class="modal-footer mt-3">
            <button class="btn btn-secondary" @click="cerrarModal">Cancelar</button>
            <button class="btn btn-primary" @click="actualizarHabitacion">Actualizar</button>
          </div>
        </div>
      </div>

      <!-- ✅ Modal Eliminar -->
      <div v-if="mostrarModalEliminar" class="modal-backdrop">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger">Confirmar Eliminación</h5>
            <button type="button" class="btn-close" @click="cerrarModalEliminar"></button>
          </div>
          <div class="modal-body">
            <p>¿Eliminar la habitación <strong>{{ habitacionEliminar?.Numero }}</strong>?</p>
          </div>
          <div class="modal-footer mt-3">
            <button class="btn btn-secondary" @click="cerrarModalEliminar">Cancelar</button>
            <button class="btn btn-danger" @click="confirmarEliminar">Eliminar</button>
          </div>
        </div>
      </div>

      <!-- Modal Gestionar Tipos de Habitación -->
      <div v-if="mostrarModalTiposHabitacion" class="modal-backdrop" @click.self="cerrarModalTipos">
        <div class="modal-content-large">
          <div class="modal-header">
            <h4 class="modal-title"><i class="bi bi-house-gear me-2"></i>Gestionar Tipos de Habitación</h4>
            <button type="button" class="btn-close" @click="cerrarModalTipos"></button>
          </div>
          <div class="modal-body-tipos">
            <!-- Formulario Crear Tipo -->
            <div v-if="mostrarFormularioTipo" class="mb-4">
              <h5 class="mb-3">Nuevo Tipo de Habitación</h5>
              <div class="row g-3">
                <div class="col-md-6">
                  <label class="form-label">Nombre</label>
                  <input v-model="nuevoTipo.Nombre" type="text" class="form-control" placeholder="Ej: Cuádruple" />
                </div>
                <div class="col-md-6">
                  <label class="form-label">Descripción</label>
                  <input v-model="nuevoTipo.Descripcion" type="text" class="form-control" placeholder="Descripción del tipo" />
                </div>
              </div>
              <div class="text-end mt-3">
                <button class="btn btn-primary me-2" @click="guardarTipo">Guardar</button>
                <button class="btn btn-secondary" @click="cancelarFormularioTipo">Cancelar</button>
              </div>
            </div>

            <button v-else class="btn btn-success mb-3" @click="mostrarFormularioTipo = true">
              <i class="bi bi-plus-circle me-1"></i>Agregar Tipo
            </button>

            <!-- Tabla de Tipos -->
            <div class="table-responsive">
              <table class="table table-bordered text-center align-middle">
                <thead class="table-light">
                  <tr>
                    <th>Nombre</th>
                    <th>Descripción</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="tiposHabitacion.length === 0">
                    <td colspan="3">No hay tipos registrados.</td>
                  </tr>
                  <tr v-for="tipo in tiposHabitacion" :key="tipo.IdTipoHabitacion">
                    <td>{{ tipo.Nombre }}</td>
                    <td>{{ tipo.Descripcion || '—' }}</td>
                    <td>
                      <button class="btn btn-primary btn-sm me-2" @click="abrirModalEditarTipo(tipo)">Editar</button>
                      <button class="btn btn-danger btn-sm" @click="abrirModalEliminarTipo(tipo)">Eliminar</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal Editar Tipo -->
      <div v-if="mostrarModalEditarTipo" class="modal-backdrop" @click.self="cerrarModalEditarTipo">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Editar Tipo de Habitación</h5>
            <button type="button" class="btn-close" @click="cerrarModalEditarTipo"></button>
          </div>
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label">Nombre</label>
                <input v-model="tipoEditar.Nombre" type="text" class="form-control" />
              </div>
              <div class="col-md-6">
                <label class="form-label">Descripción</label>
                <input v-model="tipoEditar.Descripcion" type="text" class="form-control" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="actualizarTipo">Guardar Cambios</button>
            <button class="btn btn-secondary" @click="cerrarModalEditarTipo">Cancelar</button>
          </div>
        </div>
      </div>

      <!-- Modal Eliminar Tipo -->
      <div v-if="mostrarModalEliminarTipo" class="modal-backdrop" @click.self="cerrarModalEliminarTipo">
        <div class="modal-content text-center">
          <i class="bi bi-exclamation-triangle-fill text-warning" style="font-size: 3rem"></i>
          <h5 class="mt-3">¿Eliminar tipo "{{ tipoEliminar?.Nombre }}"?</h5>
          <p class="text-muted">Esta acción no se puede deshacer.</p>
          <div class="d-flex justify-content-center gap-2 mt-3">
            <button class="btn btn-danger" @click="confirmarEliminarTipo">Eliminar</button>
            <button class="btn btn-secondary" @click="cerrarModalEliminarTipo">Cancelar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";

export default {
  name: "HabitacionGestion",
  data() {
    return {
      habitaciones: [],
      tiposHabitacion: [],
      mostrarFormulario: false,
      mostrarModal: false,
      mostrarModalEliminar: false,
      habitacionEditar: null,
      habitacionEliminar: null,
      mostrarToast: false,
      alerta: { mensaje: "", tipo: "success" },
      nuevaHabitacion: {
        Numero: "",
        IdTipoHabitacion: "",
        CantidadCamas: 1,
        Nivel: "",
        Descripcion: ""
      },
      // Gestión de tipos
      mostrarModalTiposHabitacion: false,
      mostrarFormularioTipo: false,
      mostrarModalEditarTipo: false,
      mostrarModalEliminarTipo: false,
      nuevoTipo: { Nombre: "", Descripcion: "" },
      tipoEditar: null,
      tipoEliminar: null,
      // Filtros
      busquedaNumero: "",
      filtroTipo: "",
      filtroEstado: ""
    };
  },
  computed: {
    habitacionesFiltradas() {
      return this.habitaciones.filter(hab => {
        // Búsqueda por número
        const coincideNumero =
          hab.Numero?.toLowerCase().includes(this.busquedaNumero.toLowerCase());

        // Filtro por tipo
        const coincideTipo =
          this.filtroTipo === "" || hab.IdTipoHabitacion === parseInt(this.filtroTipo);

        // Filtro por estado
        const coincideEstado =
          this.filtroEstado === "" || hab.IdEstado === parseInt(this.filtroEstado);

        return coincideNumero && coincideTipo && coincideEstado;
      });
    },
    toastColor() {
      return this.alerta.tipo === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.alerta.tipo === "success" ? "bi bi-check-circle" : "bi bi-exclamation-circle";
    }
  },
  methods: {
    cerrarToast() {
      this.mostrarToast = false;
    },
    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    async obtenerHabitaciones() {
      const res = await axios.get(`${API_URL}/habitaciones`);
      this.habitaciones = res.data;
    },
    async obtenerTiposHabitacion() {
      const res = await axios.get(`${API_URL}/tipohabitacion`);
      this.tiposHabitacion = res.data;
    },
    async guardarHabitacion() {
  const { Numero, IdTipoHabitacion, CantidadCamas } = this.nuevaHabitacion;
  if (!Numero || !IdTipoHabitacion || !CantidadCamas) {
    this.mostrarAlerta("Todos los campos son obligatorios", "danger");
    return;
  }
  try {
    // ⚡️ Siempre envía IdEstado: 4
    await axios.post(`${API_URL}/habitaciones`, {
      ...this.nuevaHabitacion,
      IdEstado: 4
    });
    this.mostrarAlerta("Habitación agregada", "success");
    this.nuevaHabitacion = { Numero: "", IdTipoHabitacion: "", CantidadCamas: 1, Nivel: "", Descripcion: "" };
    this.mostrarFormulario = false;
    this.obtenerHabitaciones();
  } catch (error) {
    console.error(error);
    this.mostrarAlerta("Error al guardar", "danger");
  }
},

    abrirModal(habitacion) {
      this.habitacionEditar = { ...habitacion };
      this.mostrarModal = true;
    },
    cerrarModal() {
      this.habitacionEditar = null;
      this.mostrarModal = false;
    },
    async actualizarHabitacion() {
      try {
        await axios.put(`${API_URL}/habitaciones/${this.habitacionEditar.IdHabitacion}`, this.habitacionEditar);
        this.mostrarAlerta("Habitación actualizada", "success");
        this.cerrarModal();
        this.obtenerHabitaciones();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al actualizar", "danger");
      }
    },
    abrirModalEliminar(habitacion) {
      this.habitacionEliminar = { ...habitacion };
      this.mostrarModalEliminar = true;
    },
    cerrarModalEliminar() {
      this.habitacionEliminar = null;
      this.mostrarModalEliminar = false;
    },
    async confirmarEliminar() {
      if (!this.habitacionEliminar) return;
      try {
        await axios.delete(`${API_URL}/habitaciones/${this.habitacionEliminar.IdHabitacion}`);
        this.mostrarAlerta("Habitación eliminada", "success");
        this.obtenerHabitaciones();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al eliminar", "danger");
      } finally {
        this.cerrarModalEliminar();
      }
    },
    cancelarFormulario() {
      this.mostrarFormulario = false;
      this.nuevaHabitacion = { Numero: "", IdTipoHabitacion: "", CantidadCamas: 1, Nivel: "", Descripcion: "" };
    },
    // Métodos para gestión de tipos
    abrirModalTipos() {
      this.mostrarModalTiposHabitacion = true;
    },
    cerrarModalTipos() {
      this.mostrarModalTiposHabitacion = false;
      this.mostrarFormularioTipo = false;
      this.nuevoTipo = { Nombre: "", Descripcion: "" };
    },
    async guardarTipo() {
      if (!this.nuevoTipo.Nombre) {
        this.mostrarAlerta("El nombre del tipo es obligatorio", "danger");
        return;
      }
      try {
        await axios.post(`${API_URL}/tipohabitacion`, this.nuevoTipo);
        this.mostrarAlerta("Tipo de habitación agregado", "success");
        this.nuevoTipo = { Nombre: "", Descripcion: "" };
        this.mostrarFormularioTipo = false;
        await this.obtenerTiposHabitacion();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al guardar el tipo", "danger");
      }
    },
    cancelarFormularioTipo() {
      this.mostrarFormularioTipo = false;
      this.nuevoTipo = { Nombre: "", Descripcion: "" };
    },
    abrirModalEditarTipo(tipo) {
      this.tipoEditar = { ...tipo };
      this.mostrarModalEditarTipo = true;
    },
    cerrarModalEditarTipo() {
      this.tipoEditar = null;
      this.mostrarModalEditarTipo = false;
    },
    async actualizarTipo() {
      try {
        await axios.put(`${API_URL}/tipohabitacion/${this.tipoEditar.IdTipoHabitacion}`, this.tipoEditar);
        this.mostrarAlerta("Tipo actualizado", "success");
        this.cerrarModalEditarTipo();
        await this.obtenerTiposHabitacion();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al actualizar el tipo", "danger");
      }
    },
    abrirModalEliminarTipo(tipo) {
      this.tipoEliminar = { ...tipo };
      this.mostrarModalEliminarTipo = true;
    },
    cerrarModalEliminarTipo() {
      this.tipoEliminar = null;
      this.mostrarModalEliminarTipo = false;
    },
    async confirmarEliminarTipo() {
      if (!this.tipoEliminar) return;
      try {
        await axios.delete(`${API_URL}/tipohabitacion/${this.tipoEliminar.IdTipoHabitacion}`);
        this.mostrarAlerta("Tipo eliminado", "success");
        await this.obtenerTiposHabitacion();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al eliminar el tipo", "danger");
      } finally {
        this.cerrarModalEliminarTipo();
      }
    },
    async cambiarADisponible(habitacion) {
      try {
        await axios.put(`${API_URL}/habitaciones/${habitacion.IdHabitacion}`, {
          IdEstado: 4
        });
        this.mostrarAlerta("Habitación cambiada a disponible", "success");
        this.obtenerHabitaciones();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al cambiar el estado", "danger");
      }
    },
    getEstadoClase(estadoId) {
      const mapas = {
        1: "bg-primary", // Ocupado
        2: "bg-warning", // Espera de limpieza
        3: "bg-info", // Limpieza
        4: "bg-success", // Disponible
        5: "bg-secondary", // Bloqueado
        7: "bg-danger" // Mantenimiento
      };
      return mapas[estadoId] || "bg-secondary";
    },
    limpiarFiltros() {
      this.busquedaNumero = "";
      this.filtroTipo = "";
      this.filtroEstado = "";
    }
  },
  mounted() {
    this.obtenerHabitaciones();
    this.obtenerTiposHabitacion();
  }
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.modal-content {
  background: #fff;
  width: 600px;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}
.modal-content-large {
  background: #fff;
  width: 90%;
  max-width: 900px;
  max-height: 90vh;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.modal-header {
  padding: 20px 30px;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-body-tipos {
  padding: 30px;
  overflow-y: auto;
  flex: 1;
}
.modal-footer {
  padding: 15px 30px;
  border-top: 1px solid #dee2e6;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
